import { render, staticRenderFns } from "./BasePhoneList.vue?vue&type=template&id=00af0002"
import script from "./BasePhoneList.vue?vue&type=script&lang=js"
export * from "./BasePhoneList.vue?vue&type=script&lang=js"
import style0 from "./BasePhoneList.vue?vue&type=style&index=0&id=00af0002&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports